import { Analysis } from 'common-spectrum';
import { hgParseThermoFinnigan } from 'physical-chemistry-parser';

export function fromThermoFinnigan(blob) {
  let analysis = new Analysis();

  const parsed = hgParseThermoFinnigan(blob);

  let meta = {
    ...parsed.meta.solidReporting,
    ...parsed.meta.testInformation,
    ...parsed.meta.analyticalConditions,
    ...parsed.meta.preparation,
    ...parsed.meta.totalPoreSize,
  };
  analysis.pushSpectrum(
    {
      x: {
        data: parsed.variables.E.data,
        label: parsed.variables.E.label,
        units: parsed.variables.E.units,
        type: 'INDEPENDENT',
      },
      y: {
        data: parsed.variables.B.data,
        label: parsed.variables.B.label,
        units: parsed.variables.B.units,
        type: 'DEPENDENT',
      },
    },
    {
      dataType: 'Hg porosimetry',
      title: parsed.meta.testInformation['Sample name'],
      meta: meta,
      tmp: parsed,
    },
  );

  return analysis;
}
